const disableReactDevTools = () => {
    if (process.env.NODE_ENV === "production") {
        if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === "object") {
            for (const prop in window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
                window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] =
                    typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] === "function"
                        ? () => {}
                        : null;
            }
        }
    }
};

const disableConsole = () => {
    if (process.env.NODE_ENV === "production") {
        console.log = () => {};
        console.warn = () => {};
        console.error = () => {};
    }
};

export{
    disableReactDevTools,
    disableConsole
}